import Link from 'next/link'
import React, { memo } from 'react'

type NewsListType = {
  link: string
  time: string
  text: string
  query: string
}

export const NewsList = memo(({ link, time, text, query }: NewsListType) => {
  return (
    <div className="c_news py-2">
      <p className="text-xs text-color01">
        <time>{time}</time>
      </p>
      <Link
        href={{
          pathname: `${link}`,
          query: { query: query },
        }}
        legacyBehavior={true}
      >
        <a className="mt-2 block text-sm">{text}</a>
      </Link>
    </div>
  )
})
